import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import des fichiers de traduction
import translationDE from "./locales/de/translation.json";
import translationFR from "./locales/fr/translation.json";

// Ressources de traduction
const resources = {
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
};

// Configuration d'i18next
void i18n
  .use(initReactI18next) // Initialisation pour React
  .init({
    resources,
    lng: "de", // Langue allemande définie par défaut
    fallbackLng: "de", // Langue de secours également en allemand
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React gère déjà l'échappement
    },
  });

export default i18n;
